import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/stock/odt/order/orderlist-filter/';
}

/**
 * @typedef {'day'|'session'}  OrderPeriod
 */

/**
 * Docs?:
 * https://ajaib.atlassian.net/wiki/spaces/STOCK/pages/163282981/Order+List+Filter+Endpoint+Migration#API-Contract
 *
 * @typedef   {object}  DtOrderDetail
 *
 * @property  {string}      order_no              (Ex: '20014')
 * @property  {string}      idx_order_no          (Ex: '202305300000000016')
 * @property  {string}      transaction_type      (Ex: '1') -> 1 = Buy
 * @property  {string}      stock                 (Ex: 'BBRI')
 * @property  {string}      market_type           (Ex: '0RG')
 * @property  {number}      price_order           (Ex: 5775)
 * @property  {number}      lot_input             (Ex: 1)
 * @property  {number}      open_order            (Ex: 0)
 * @property  {number}      done_order            (Ex: 1)
 * @property  {number}      shares_input          (Ex: 100)
 * @property  {number}      openshares_order      (Ex: 100)
 * @property  {number}      doneshares_order      (Ex: 0)
 * @property  {string}      order_time            (Ex: '2023-05-30T15:58:39.000000')
 * @property  {string}      executed_time         (Ex: '18:46:05')
 * @property  {string}      message               (Ex: '-')
 * @property  {string}      status                (Ex: '0')
 * @property  {string}      status_description    (Ex: 'Open')
 * @property  {number}      total_price           (Ex: 577500)
 * @property  {number?}     lowvolamend           (Ex: 577500)
 * @property  {number?}     highvolamend          (Ex: 577500)
 * @property  {string}      is_ammend             (Ex: '1')
 * @property  {string}      is_cancel             (Ex: '1')
 * @property  {boolean}     is_forcesell          (Ex: false)
 * @property  {OrderPeriod} period                (Ex: false)
 * @property  {number}      lowest_ask            (Ex: false)
 * @property  {string[]}    automation_order_item_types   (Ex: ["STOP_LOSS", "TAKE_PROFIT"])
 *
 */

/**
 * @typedef   {object}  DtOrderDetailResponse
 *
 * @property  {object}                    data
 * @property  {string}                    data.err_code      (Ex: "EC0000000")
 * @property  {string}                    data.err_message   (Ex: "APPROVED/OK")
 * @property  {DtOrderDetail[]}       data.results
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 * @param {string} url
 * @param {string} orderNo
 * @returns
 */
function callbackFetch(url, orderNo) {
  return async () => {
    try {
      /**
       * @type {DtOrderDetailResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          order_no: orderNo,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function getV1StockOdtOrderOrderlistfilterById(orderNo) {
  const url = getUrl();
  const cb = callbackFetch(url, orderNo);
  const key = [url, orderNo];

  return { cb, key };
}
